import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { SynonymEntrySchema } from './synonym.validator';

export const QualityEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string().optional().nullable(),
    synonyms: z.array(SynonymEntrySchema).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
